import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=2082bc47&scoped=true&lang=pug"
import script from "./BaseHeader.vue?vue&type=script&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&lang=ts"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=2082bc47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082bc47",
  null
  
)

export default component.exports